const tinycolor = require("tinycolor2");

export const getBaseURL = (includeProtocol = true) => {
  var url = window.location.href;
  var arr = url.split('/');
  var URLString = '';
  if(includeProtocol){
    URLString += arr[0] + '//' + arr[2];
  } else {
    URLString += '//' + arr[2];
  }
  return URLString;
};

/*
--  Capitalize the first letter of a string --
*/
export const capitalizeFirstLetter = (string) => {
  if(!string) return false;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/*
--  Get Array from Encoded String --
*/
export const getArrayFromEncodedString = (string) => {
  /**
   * `single+family+home` was being passed in here, when we needed `single family home`
   */
  string = string.replaceAll('%2B', ' ')
  string = string.replaceAll('+', ' ')
  string = unescape(string);
  return string.split(',');
};

/*
--  Get the Data Object from the DOM, return as jSON --
*/
export const getDataObject = (el = 'vue-data-object') => {
  const dataObjectHolder = document.getElementById(el);
  if(!dataObjectHolder || !dataObjectHolder.dataset.object) return false;
  let dataObject = JSON.parse(dataObjectHolder.dataset.object);
  return dataObject;
};

/*
--  Get IDs from an array of objects --
*/
export const parseIds = (arr) => {
  return arr.map((item) => {
    return item.id.toString();
  });
};

/*
--  Parse Field --
*/
export const parseField = (arr, fieldName) => {
  try {
    return arr.map((item) => {
      return item[fieldName].toString();
    });
  }
  catch (err) {
    console.error(err);
    console.error(arr);
  }
};

/*
--  Get array of objects with id and name from array of objects --
*/
export const parseIdsAndNames = (arr) => {
  return arr.map((item) => {
    return {
      id: item.id.toString(),
      name: item.name
    };
  });
};


/*
--  Calc Helpers --
*/

export const toDecimals = (value, decimals = 2) => {
  return parseFloat((value * 100).toFixed(decimals));
};

export const roundToDecimals = (value, decimals = 0) => {
  value = value * 100;
  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);  
  return value;
};

export const roundToTwoDecimals = (num) => {
  return Math.round(num * 100) / 100;
};

export const numberWithCommas = (x) =>{
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const parseIntNoCommas = (num) =>{
  if(num == undefined) return num;
  var a = num.toString().replace(/\,/g,''); // 1125, but a string, so convert it to number
  a = parseInt(a,10);
  return a;
};

export const parseFloatNoCommas = (num) =>{
  if(num == undefined) return num;
  var a = num.toString().replace(/\,/g,''); // 1125, but a string, so convert it to number
  a = parseFloat(a,10);
  return a;
};

export const floatToPercent = (num) =>{
  return num * 100;
};

export const percentToFloat = (num) =>{
  return num / 100;
};

export const noChange = (value = 0) => {
  try {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0];
  } catch(e) {
    console.warn(e);
    return false;
  }
};

/*
--  Strip out all non-numeric characters --
*/
export const stripOutNonNumeric = (value) => {
  if(!value) return false;
  try { return value.replace(/\D/g,''); }
  catch(e){
    console.warn(e);
    return value;
  }
};



// get coordinates from property object
export const convertPropertyCoords = (properties) => {
  let filteredProperties = properties.filter(prop => parseFloat(prop.lat) != 0 && parseFloat(prop.lng) != 0);
  return filteredProperties.map(property => {
    let newProp = {...property};
    newProp.lat = parseFloat(property.lat);
    newProp.lng = parseFloat(property.lng);
    return newProp;
  });
};

export const sortResults = (array, key) => {
  return array.sort(function(a, b) {
    var x = a[key]; var y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
};

export const getDistance = (lat1, lon1, lat2, lon2, unit) => {
  if(lat1 == lat2 && lon1 == lon2)
    return 0;

  var radlat1 = Math.PI * lat1/180;
  var radlat2 = Math.PI * lat2/180;
  var radlon1 = Math.PI * lon1/180;
  var radlon2 = Math.PI * lon2/180;
  var theta = lon1-lon2;
  var radtheta = Math.PI * theta/180;
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = dist * 180/Math.PI;
  dist = dist * 60 * 1.1515;
  if (unit=='K') { dist = dist * 1.609344; }
  if (unit=='N') { dist = dist * 0.8684; }
  return dist;
};

/*
--  Create slug from string ("Foo bar"  ->  "foo-bar") --
*/
export const slugify = (text) => {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

/*
--  Convert a string with underscores to camel case --
*/
export const underscoresToCamelCase = (text) => {
  return text.replace(/(\_[a-z])/g, function($1){return $1.toUpperCase().replace('_','');});
};

/*
--  Convert an Object into a query string --
*/
export const getQueryString = ( params, fieldsToSkip = [] ) => {
  var str = [];
    
  if(!Array.isArray(fieldsToSkip)) { console.error('Invalid fields array'); return false; }
    
  for(var p in params){
    if(fieldsToSkip.includes(p)) continue;
    if(!params[p] || typeof(params[p]) == 'string' && params[p] == ''){
      continue;
    }
    if(!params[p] || typeof(params[p]) == 'object' && params[p].length == 0){
      continue;
    }
    if (params.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
    }
  }
  return str.join('&');
};


/*
--  Convert to Thousands (122000 => 122k) --
*/
export const convertToThousandsLabel = ( number, type = 'for-sale' ) => {
  if(type == 'for-sale'){
    if(parseFloat(number) >= 1000000){
      return '$' + (parseFloat(number / 1000000).toFixed(1)).toString() + 'm';
    } else {
      return '$' + (parseInt(number / 1000)).toString() + 'k';
    }
  } else {
    if(parseFloat(number) > 1000){
      return '$' + (parseFloat(number / 1000).toFixed(1)).toString() + 'k';
    } else {
      return '$' + parseFloat(number);
    }
  }
};


/*
--  Convert field based on field type --
--  readingInFromDB : this parameter exists because this function converts user inputted fields, as well as db-read fields. DB stores percentages as "0.1234" where a user enters 12.34
*/
export const convertField = (fieldTypes, fieldName, value, readingInFromDB = false) => {
  if(!fieldTypes){ console.warn('covertField :: undefined fieldTypes'); return value;}
  if(value == null) return value;
  let newValue = value;
  if(fieldTypes.pct.includes(fieldName) && readingInFromDB){
    newValue = roundToDecimals(newValue, 2);
    if(isNaN(newValue) || newValue < 0 || newValue > 100) newValue = '';
  } else if(fieldTypes.float.includes(fieldName) || (fieldTypes.pct.includes(fieldName) && !readingInFromDB)) {
    newValue = parseFloat(value);
    if(isNaN(newValue) || newValue < 0) newValue = '';
  } else if(fieldTypes.int.includes(fieldName)) {
    newValue = parseInt(value);
    if(isNaN(newValue) || newValue < 0 || newValue > 99999999999) newValue = '';
  } else if(fieldTypes.bool.includes(fieldName)) {
    newValue = Boolean(newValue);
  }
  return newValue;
};


/*
--  Split Location Code --
--  `market-91` => {level: 'market', id: 91}
*/
export const splitLocationCode = (code) => {
  try { 
    return { 
      level: code.split('-')[0], 
      id: code.split('-')[1] 
    }; 
  } catch(e){ console.warn(e); return false; }
};

/**
 * Get ROI Confidence
 * @param {object} property The property you want to calculate roi confidence for
 */
export const getRoiConfidence = (resource) => {
  try {
    const reasons = [];
    const maxScore = 100;
    const factors = [
      'property_taxes', 
      'maintenance_costs', 
      'management_costs', 
      'insurance_costs', 
      'rent_amt'
    ];

    let currentScore = 100;

    factors.forEach(factor => {
      // if column doesnt exist on the row, or if the column is falsy
      if(!resource.hasOwnProperty(factor) || !parseFloat(resource[factor])){
        //  - Reformat the name of the factor that failed the conditional to "Property Taxes", for example
        //  - Push the reason into the reasons array array
        reasons.push(factor.split('_').map(str => capitalizeFirstLetter(str)).join(' '));
        // Decrease the current score by the appropriate amount
        currentScore -= (maxScore  / factors.length);
      }
    });

    return {
      score: currentScore,
      reasons
    };
        
  } catch (e) { console.warn(e); }
};

/**
 * Disclaimer Section- strip out empty tags that only have &nbsp;
 */
export const cleanMlsDisclaimer = () => {
  const disclaimerSection = document.querySelector('.mls-disclaimer-section');
  if(disclaimerSection && disclaimerSection.childNodes.length){
    disclaimerSection.childNodes.forEach(el => {
      if(el.innerHTML == '&nbsp;') el.remove();
    });
  }
};

/**
 * Extract Financials. Take an object and return the financials fields from it
 */
export const extractFinancials = (obj, fieldsToSkip = []) => {
  let financials = {};

  const financialsFields = [
    // financing
    'asking_price',
    'cap_ex_amt',
    'down_pmt_rate',
    // 'down_pmt_amt',
    'mortgage_amt',
    'mortgage_rate',
    'closing_costs',
    'mortgage_pmt',
    
    // Income
    'rent_amt',
    'gross_rent',
    'vacancy_amt',
    'vacancy_rate',
    'effective_rent',
    'gross_yield',

    // Expenses
    'property_taxes',
    'management_costs',
    'management_rate',
    'maintenance_costs',
    'maintenance_reserve',
    'insurance_costs',
    'insurance_rate',
    'hoa_dues',
    'total_operating_expenses',

    // Financials
    'net_operating_income',
    'expense_load',
    'total_cash_outlay',
    'net_yield',
    'cash_flow',
    'cash_on_cash',
    'roi',

    // not shown in the calculator
    'current_value',
  ];

  financialsFields.map(key => {
    /**
     * This was put here so that when we are reading in a property, we can read in the mortgage_rate. When we are reading in a listing, we need to ingore the mortgage_rate field
     */
    if(!fieldsToSkip.includes(key)) {
      let val = obj[key];
      financials[key] = val;
    }
  });

    
  return financials;
};

/**
 * Get data object from query params in the URL
 */
export const getDataFromQueryParams = (obj) => {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  let dataObj = {};

  for (var i = 0; i < vars.length; i++) {

    var pair = vars[i].split('=');
    let key = pair[0];
    let value = decodeURIComponent(pair[1]);


    if(!key) continue;

    dataObj[key] = value;

  }

  return dataObj;
};

/**
 *
 * @param sectionNumber
 *
 * "https://renterswarehouse.com/re/slug"
 * getUrlSection(0) => 're'
 * getUrlSection(1) => 'slug'
 */
export const getUrlSection = (sectionNumber) => {
  var components = window.location.pathname.split('/');
  if (components.length - 1 < sectionNumber) {
    return '';
  }
  return components[sectionNumber];
};

/**
 * Decode Query String Component
 * "Altamonte+Springs%2C+FL%2C+USA" -> "Altamonte Springs, FL, USA"
 */
export const decodeQueryStringComponent = (x) => {
  x = x.replace(/\+/g, '%20'); // '1%20%2B%201%20%3D%202'
  x = decodeURIComponent(x);   // '1 + 1 = 2'
  return x;
};

/**
 * Get data object from query params in the URL
 */
export const handleErrors = (res) => {
  const { response } = res;
  if(response  && response.status == 401){
    swal({
      title: 'Session Expired',
      text: 'Please click below to re-authenticate.',
      icon: 'warning',
      buttons: ['Cancel', 'Re-Authenticate']
    }).then((value) => {

      if (value) {
        window.location.reload(true);
        return false;
      }
    });
  } else {
    console.error(err);
  }
};

/**
 * Global API Response Error Handler
 */
export const handleAPIErrors = (err) => {
  console.warn('handleAPIErrors :: ', err);
  console.warn('response :: ', err.response);
  let title = 'Error';
  let message = 'There was an issue with your request. Please contact support.';
  if(err.response && err.response.data && err.response.data.error){
    // Controller manually threw an error
    title = 'Invalid Action';
    message = err.response.data.error;
  } else if(err.response && err.response.data && err.response.data.errors){
    let errStr = Object.values(err.response.data.errors).join(', ');
    // Controller manually threw an error
    title = 'Invalid Action';
    message = `Please adjust the following errors in your submission: ${errStr}`;
  } else if(err.response && err.response.data && err.response.data.message){
    // App threw a stack trace error
    title = 'Invalid Action';
    message = err.response.data.message;
  }
  swal({
    title,
    icon: 'warning',
    text: message,
  });
};

/**
 * Light or Dark
 * Programatically determine whether a color is light or dark
 * https://awik.io/determine-color-bright-dark-using-javascript/
 * @param {string} color The color value we are looking at 
 * @param {string} tolerance This is used to give some flexibility to this function -- "do not consider this color light unless it is VERY light"
 */
export const lightOrDark = (color, tolerance = 0) => {

  // Variables for red, green, blue values
  var r, g, b, hsp;
  
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {

      // If RGB --> store the red, green, blue values in separate variables
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
      
      r = color[1];
      g = color[2];
      b = color[3];
  } 
  else {
      
      // If hex --> Convert it to RGB: http://gist.github.com/983661
      color = +("0x" + color.slice(1).replace( 
      color.length < 5 && /./g, '$&$&'));

      r = color >> 16;
      g = color >> 8 & 255;
      b = color & 255;
  }
  
  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(
  0.299 * (r * r) +
  0.587 * (g * g) +
  0.114 * (b * b)
  );

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > (127.5 + tolerance)) {

      return 'light';
  } 
  else {

      return 'dark';
  }
}

/**
 * Tinycolor wrapper
 */
export const tinyAdjust = (color, action, amt) => {
  return tinycolor(color)[action](amt);
}


/**
 * Get Location Type
 * Using the Google Places Details response, return a location type ("zipcode", "city", "county", "state")
 */
export const getGoogleAPILocationType = (response) => {
  
  let type = '';

  let primaryComponent = response.address_components[0];

  if(!primaryComponent.types) {
    console.error('invalid address component');
    return false;
  }

  if(primaryComponent.types.includes('postal_code')) {
    type = 'zipcode';
  } else if(primaryComponent.types.includes('locality')) {
    type = 'city';
  } else if(primaryComponent.types.includes('administrative_area_level_2')) {
    type = 'county';
  } else if(primaryComponent.types.includes('administrative_area_level_1')) {
    type = 'state';
  } else if(primaryComponent.types.includes('street_number')) {
    type = 'address';
  }

  return type;
}



/*
--  Get IDs from an array of objects --
*/
export const truncateString = (str, num) => {
  // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + '...'
};

export const flattenProperty = (p) => {
  // separate base property record into its own object
  let baseProperty = {...p.property};
  // remove base property fields from the related record (the parent object)
  delete p.property;
  // flatten base property fields with related record fields
  const newProperty = {
    ...baseProperty,
    ...p
  };
  return newProperty;
};

export const flattenProperties = (properties) => {
  let clonedProperties = properties.map(p => p);
  let newProperties = [];
  clonedProperties.forEach(p => {
    const newProperty = flattenProperty(p);
    newProperties.push(newProperty);
  })
  return newProperties;
};

export const flattenPortfolios = (portfolios) => {
  let clonedPortfolios = portfolios.map(p => p);
  let newPortfolios = [];
  clonedPortfolios.forEach(portfolio => {
    const newProperties = flattenProperties(portfolio.properties);
    const newPortfolio = {...portfolio};
    newPortfolio.properties = newProperties;
    newPortfolios.push(newPortfolio);
  })
  return newPortfolios;
};


export const flattenPortfolioListing = (p) => {
  // separate base porrtfolio record into its own object
  let basePortfolio = {...p.portfolio};
  // remove base portfolio fields from the related record (the parent object)
  delete p.portfolio;
  // flatten base portfolio fields with related record fields
  const newProperty = {
    ...basePortfolio,
    ...p
  };
  return newProperty;
};

export const getPricingLabel = (filters, searchType) => {
  let minFilter = false;
  let maxFilter = false;
  minFilter = filters.filter(({field}) => field == 'min_asking_price')[0]; // IE11 did not like .find() .....
  maxFilter = filters.filter(({field}) => field == 'max_asking_price')[0]; // IE11 did not like .find() .....
  
  if(minFilter && maxFilter){
      return convertToThousandsLabel(minFilter.value, searchType) + ' - ' + convertToThousandsLabel(maxFilter.value, searchType);
  } else if(minFilter){
      return '> ' + convertToThousandsLabel(minFilter.value, searchType);
  } else if(maxFilter){
      return '< ' + convertToThousandsLabel(maxFilter.value, searchType);
  }
  return false;
}

export const getBedsLabel = (filters) => {
  let minFilter = false;
  let maxFilter = false;
  minFilter = filters.filter(({field}) => field == 'min_beds')[0]; // IE11 did not like .find() .....
  maxFilter = filters.filter(({field}) => field == 'max_beds')[0]; // IE11 did not like .find() .....

  if(minFilter && maxFilter){
      return minFilter.value + ' - ' + maxFilter.value + ' beds';
  } else if(minFilter){
      return '> ' + minFilter.value + ' beds';
  } else if(maxFilter){
      return '< ' + maxFilter.value + ' beds';
  }
  return false;
}

export const getBathsLabel = (filters) => {
  let minFilter = false;
  let maxFilter = false;
  minFilter = filters.filter(({field}) => field == 'min_baths')[0]; // IE11 did not like .find() .....
  maxFilter = filters.filter(({field}) => field == 'max_baths')[0]; // IE11 did not like .find() .....

  if(minFilter && maxFilter){
      return minFilter.value + ' - ' + maxFilter.value + ' baths';
  } else if(minFilter){
      return '> ' + minFilter.value + ' baths';
  } else if(maxFilter){
      return '< ' + maxFilter.value + ' baths';
  }
  return false;
}

export const getGrossYieldLabel = (filters) => {
  let minFilter = false;
  let maxFilter = false;
  minFilter = filters.filter(({field}) => field == 'min_gross_yield')[0]; // IE11 did not like .find() .....
  maxFilter = filters.filter(({field}) => field == 'max_gross_yield')[0]; // IE11 did not like .find() .....

  if(minFilter && maxFilter){
      return minFilter.value + '% - ' + maxFilter.value + '% GY';
  } else if(minFilter){
      return '> ' + minFilter.value + '% GY';
  } else if(maxFilter){
      return '< ' + maxFilter.value + '% GY';
  }
  return false;
}

export const getROILabel = (filters) => {
  let minFilter = false;
  let maxFilter = false;
  minFilter = filters.filter(({field}) => field == 'min_roi')[0]; // IE11 did not like .find() .....
  maxFilter = filters.filter(({field}) => field == 'max_roi')[0]; // IE11 did not like .find() .....

  if(minFilter && maxFilter){
      return minFilter.value + '% - ' + maxFilter.value + '% ROI';
  } else if(minFilter){
      return '> ' + minFilter.value + '% ROI';
  } else if(maxFilter){
      return '< ' + maxFilter.value + '% ROI';
  }
  return false;
}

export const getSqftLabel = (filters) => {
  let minFilter = false;
  let maxFilter = false;
  minFilter = filters.filter(({field}) => field == 'min_sqft')[0]; // IE11 did not like .find() .....
  maxFilter = filters.filter(({field}) => field == 'max_sqft')[0]; // IE11 did not like .find() .....

  if(minFilter && maxFilter){
      return minFilter.value + ' - ' + maxFilter.value + ' Sqft.';
  } else if(minFilter){
      return '> ' + minFilter.value + ' Sqft.';
  } else if(maxFilter){
      return '< ' + maxFilter.value + ' Sqft.';
  }
  return false;
}

/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
 export const getCookie = (name) => {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}